import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import './i18n'
import { initTracking } from './lib/tracking'
import { initVisitorTracker } from './lib/visitorTracker'

initTracking()
initVisitorTracker()

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
